import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import AccountRepresentativesContext from './AccountRepresentativesContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const AccountRepresentativesProvider: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <AccountRepresentativesContext.Provider value={{ actions, selectors, state }}>
      {children}
    </AccountRepresentativesContext.Provider>
  );
};

export default AccountRepresentativesProvider;
